import ApiService from "@/core/services/api.service";
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const ADDTABLE = "addTable";
export const ADDFORM = "addForm";
export const DELETEtABLE = "deleteTable";
export const CLIENTSALL = 'clientsAll';
export const PARENT = 'parent';//获取父菜单
export const BUTTONPARENT = 'buttonParent';//获取按钮父菜单
//mutations types
export const SETTABLE = "setTable";


const state = {
    tablesData: []
};


const actions = {
    // [CHANGE_MENUS]({ commit }) {
    //   commit(SET_CHANGE_MENUS, MENU);
    //   return MENU;
    // },
    [BUTTONPARENT]() {
        return ApiService.get(`/api-user/menus/findAlls`)
    },
    [CLIENTSALL]() {
        return ApiService.get(`/api-uaa/clients/all`);
    },
    [PARENT]() {
        return ApiService.get(`/api-user/menus/findOnes`);
    },
    [DELETEtABLE]({ commit }, id) {
        console.log(commit)
        return ApiService.delete(`/api-user/menus/${id}`);
    },
    [ADDFORM]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-user/menus/saveOrUpdate`, o, { type: 'json' })
    },
    [ADDTABLE]({ commit }, { page, limit, keywords, clientId }) {
        console.log(commit)
        var url = `/api-user/menus/findAlls?page=${page}&limit=${limit}`;
        if (keywords) {
            url += `&keywords=${keywords}`;
        }
        if (clientId) {
            url += `&clientId=${clientId}`
        }
        return ApiService.get(url)
    },

};
const mutations = {
    [SETTABLE](state, data) {
        state.tablesData = data;
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
